import { render, staticRenderFns } from "./TrainerClients.vue?vue&type=template&id=0ea502f0&scoped=true"
import script from "./TrainerClients.vue?vue&type=script&lang=js"
export * from "./TrainerClients.vue?vue&type=script&lang=js"
import style0 from "./TrainerClients.vue?vue&type=style&index=0&id=0ea502f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea502f0",
  null
  
)

export default component.exports